/**
@author: Nikhil 
============
@desc: factory to get month and year data in different formats to be used in UI widgets. 

Todo: internationalize this data
Todo: Update jv.weekcalendar to use this constants file
Todo: Add week data in different formats
 **/

angular.module('jv.Common.Constants.Dates',[])
//factory to return month values for a drop down.
.factory('months', function() {
    return {
        formats: {
            fullmonths : [
                    {
                        value: '00',
                        name: 'January',
                        label: 'January'
                    },
                    {
                        value: '01',
                        name: 'February',
                        label: 'February'
                    },
                    {
                        value: '02',
                        name: 'March',
                        label: 'March'
                    },
                    {
                        value: '03',
                        name: 'April',
                        label: 'April'
                    },
                    {
                        value: '04',
                        name: 'May',
                        label: 'May'
                    },
                    {
                        value: '05',
                        name: 'June',
                        label: 'June'
                    },
                    {
                        value: '06',
                        name: 'July',
                        label: 'July'
                    },
                    {
                        value: '07',
                        name: 'August',
                        label: 'August'
                    },
                    {
                        value: '08',
                        name: 'September',
                        label: 'September'
                    },
                    {
                        value: '09',
                        name: 'October',
                        label: 'October'
                    },
                    {
                        value: '10',
                        name: 'November',
                        label: 'November'
                    },
                    {
                        value: '11',
                        name: 'December',
                        label: 'December'
                    }
            ],
            shortmonths : [
                    {
                        value: '00',
                        name: 'Jan',
                        label: 'Jan'
                    },
                    {
                        value: '01',
                        name: 'Feb',
                        label: 'Feb'
                    },
                    {
                        value: '02',
                        name: 'Mar',
                        label: 'Jan'
                    },
                    {
                        value: '03',
                        name: 'Apr',
                        label: 'Apr'
                    },
                    {
                        value: '04',
                        name: 'May',
                        label: 'May'
                    },
                    {
                        value: '05',
                        name: 'Jun',
                        label: 'Jun'
                    },
                    {
                        value: '06',
                        name: 'Jul',
                        label: 'Jul'
                    },
                    {
                        value: '07',
                        name: 'Aug',
                        label: 'Aug'
                    },
                    {
                        value: '08',
                        name: 'Sep',
                        label: 'Sep'
                    },
                    {
                        value: '09',
                        name: 'Oct',
                        label: 'Oct'
                    },
                    {
                        value: '10',
                        name: 'Nov',
                        label: 'Nov'
                    },
                    {
                        value: '11',
                        name: 'Dec',
                        label: 'Dec'
                    }
            ]
        }
    };
})
//factory to return year values for a drop down defaults to 10 years in the past.
.factory('years', function() {
    return {
        setRange : function(rangeValue){
            this.yearRange = rangeValue;
        },
        yearRange: 50,
        getYears: function(){
            //get todays date in user timezone

            var getTodayDateUserTimezone = function() {
                var userTimeZone = _jvselfUser.locale.timezone;
                var todayDate = new Date( moment.tz(new Date(),userTimeZone).format('MM/DD/YYYY') );
                return todayDate;
            };

            //get todays date in user timzone
            var d = getTodayDateUserTimezone();
            var yearValues = [];

            var yearRange = this.yearRange;
            for(var i = 0; i< yearRange; i++){
                var yearObject = {};
                //Select 2 behaves differently if values are set to numbers
                yearObject.name =  (d.getFullYear()-i).toString();
                yearObject.value =  (d.getFullYear()-i).toString();
                yearObject.label = (d.getFullYear()-i).toString();
                yearValues.push(yearObject);
            }

            return yearValues;
        }
    };
});

